import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

const UsersDeleteSlice = createSlice({
  name: "UsersDelete",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteUser(state, _action: PayloadAction<string>) {
      state.isLoading = true;
    },
    successDeleteUser(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteUser(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteUser(state) {
      state.isLoading = false;
      state.data = {};
    },
  },
});

export const {
  deleteUser,
  successDeleteUser,
  failureDeleteUser,
  clearDeleteUser,
} = UsersDeleteSlice.actions;

export default UsersDeleteSlice.reducer;
